var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", { attrs: { "on-add": _vm.showAdd, page: _vm.page } }),
      _c("filter-manager", {
        ref: "filter",
        attrs: { filters: _vm.filters, "open-advanced": _vm.isOpenAdvanced },
        on: { search: _vm.search },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _c("separator", {
        staticClass: "my-3",
        attrs: { text: "Lugares de Servicio" }
      }),
      _vm._l(_vm.serviceLocations, function(item, i) {
        return _c("custom-callout", { key: i, staticClass: "pb-2" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }, [
              _c("span", { staticClass: "font-14 color-gray-6" }, [
                _vm._v("Tipo de Lugar:")
              ]),
              _c("p", { staticClass: "font-16 color-black" }, [
                _vm._v(_vm._s(item.locationTypeName))
              ])
            ]),
            _c("div", { staticClass: "col-sm" }, [
              _c("span", { staticClass: "font-14 color-gray-6" }, [
                _vm._v("Municipio:")
              ]),
              _c("p", { staticClass: "font-16 color-black" }, [
                _vm._v(_vm._s(item.municipalityName))
              ])
            ]),
            _c("div", { staticClass: "col-sm-4" }, [
              _c("span", { staticClass: "font-14 color-gray-6" }, [
                _vm._v("Nombre Lugar de Servicio:")
              ]),
              _c("p", { staticClass: "font-16 color-black" }, [
                _vm._v(_vm._s(item.locationName))
              ])
            ]),
            _c("div", { staticClass: "col-sm" }, [
              _c("span", { staticClass: "font-14 color-gray-6" }, [
                _vm._v("Teléfono:")
              ]),
              _c("p", { staticClass: "font-16 color-black" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("phone")(item.locationTelephoneNo)) + " "
                )
              ])
            ]),
            item.isCertified !== null &&
            _vm.isMedicaidDocumentationWorkflowEnabled
              ? _c(
                  "div",
                  { staticClass: "col-sm d-flex align-items-center" },
                  [
                    _c("certification-badge", {
                      attrs: { text: "Certificada", value: item.isCertified }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-sm d-flex align-items-center" },
              [
                _c("action-button", {
                  staticClass: "w-60",
                  attrs: {
                    i: "fas fa-file-import",
                    text: "Entrar",
                    variant: "outline-success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onDetailClick(item)
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      }),
      _vm.serviceLocations.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible" }
          })
        : _vm._e(),
      _vm.serviceLocations.length > 0
        ? _c("pagination", {
            attrs: { data: _vm.paginationData },
            on: { "pagination-go-page": _vm.pageChanged }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }